const Edit = {
  sm: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.7286 6.02792L10.0079 4.29259L11.6539 2.67925L13.3186 4.35859C13.3226 4.36259 13.3153 4.42659 13.3199 4.43059L11.7286 6.02792ZM4.39325 13.3333H2.66659V11.5859L9.05658 5.22725L10.7866 6.97192L4.39325 13.3333ZM14.6666 4.37125C14.6619 4.00059 14.5146 3.65792 14.2653 3.41992L12.6126 1.75325C12.3666 1.49059 12.0159 1.33792 11.6493 1.33325H11.6313C11.2639 1.33325 10.9079 1.48125 10.6526 1.73792L1.52992 10.8359C1.40459 10.9606 1.33325 11.1313 1.33325 11.3086V13.9999C1.33325 14.3686 1.63125 14.6666 1.99992 14.6666H4.66859C4.84525 14.6666 5.01392 14.5973 5.13859 14.4726L14.2653 5.37125C14.5253 5.10859 14.6719 4.74392 14.6666 4.37125Z"
        fill="#A1A3A7"
        className="icon-color"
      />
    </svg>
  ),
  md: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        className="icon-color"
        d="M11.7286 6.02792L10.0079 4.29259L11.6539 2.67925L13.3186 4.35859C13.3226 4.36259 13.3153 4.42659 13.3199 4.43059L11.7286 6.02792ZM4.39325 13.3333H2.66659V11.5859L9.05658 5.22725L10.7866 6.97192L4.39325 13.3333ZM14.6666 4.37125C14.6619 4.00059 14.5146 3.65792 14.2653 3.41992L12.6126 1.75325C12.3666 1.49059 12.0159 1.33792 11.6493 1.33325H11.6313C11.2639 1.33325 10.9079 1.48125 10.6526 1.73792L1.52992 10.8359C1.40459 10.9606 1.33325 11.1313 1.33325 11.3086V13.9999C1.33325 14.3686 1.63125 14.6666 1.99992 14.6666H4.66859C4.84525 14.6666 5.01392 14.5973 5.13859 14.4726L14.2653 5.37125C14.5253 5.10859 14.6719 4.74392 14.6666 4.37125Z"
        fill="#A1A3A7"
      />
    </svg>
  ),
}

export default Edit
